import { WF_CATEGORIES, WF_TEMPLATES, WF_FLOWS, WF_FLOW, WF_FLOW_HISTORY } from '@/store/actions/workflows.actions';

const initialState = {
  wf_categories: [],
  wf_templates: [],
  wf_flows: [],
  wf_flows_meta: {},
  wf_flow: {},
  wf_flow_history: [],
  wf_flow_history_meta: {}
};

export default function workflowReducer(state = initialState, action) {
  switch (action.type) {
    case WF_CATEGORIES:
      return {
        ...state,
        wf_categories: action.payload.data
      };
    case WF_TEMPLATES:
      return {
        ...state,
        wf_templates: action.payload.data
      };
    case WF_FLOWS:
      return {
        ...state,
        wf_flows: action.payload.data,
        wf_flows_meta: action.payload.meta
      };
    case WF_FLOW:
      return {
        ...state,
        wf_flow: action.payload.data
      };
    case WF_FLOW_HISTORY:
      return {
        ...state,
        wf_flow_history: action.payload.data,
        wf_flow_history_meta: action.payload.meta
      };
    default:
      return state;
  }
}
